import React from "react";
import { Button } from "react-bootstrap";
import QRCode from "react-qr-code";

class WebQrScan extends React.Component {
    state = {
        storedFiles: [],
        show: false,
        id: ""
    }

    downloader = async () => {
        if (this.state.show) {
            this.setState({ loading: true });
            const _res = await this.props._api({
              ...this.props,
              method: "GET",
              data: this.state.files,
              endpoint: "/api/service/GetFile/GetFile/" + this.state.id,
              param: "",
            });
            this.setState({ loading: false });
            if (_res.status === 200) {
                _res.data.map((x,idx) => {
                    debugger;
                    this.props.SetImg(x);
                });
            }
        }
        
        return;
    }

    loaderScanImg = async () => {
        setInterval(await this.downloader,1000);
    }

    uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          // eslint-disable-next-line no-mixed-operators
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
      }

      componentDidMount() {
        this.setState({id: this.uuidv4()});
        this.loaderScanImg();
      }

    render() {
        const { Bs, SIZE, VARIANT } = this.props;
        return (
            <>
                {this.state.show && (
                    <Bs modal
                        show={this.state.show}
                        onHide={() => this.setState({ show: false })}
                        keyboard={false}
                        backdrop="static"
                        centered
                        size={SIZE.LG}
                        aria-labelledby="contained-modal-title-vcenter">
                        <Bs modalheader closeButton>
                            Scanování pomocí mobilního telefonu
                        </Bs>
                        <Bs modalbody>
                            <Bs row>
                                <Bs col xs={12} lg={6}>
                                    <Bs span className="text-muted mb-4">
                                        <Bs row><Bs strong className="me-2 mb-2">Android</Bs></Bs>
                                        Pro použití QR kódu potřebuješ mít staženou aplikaci
                                        <Bs button
                                            variant={VARIANT.LINK}
                                            onClick={() => window.open("https://play.google.com/store/apps/details?id=la.droid.qr", "_blank")}>
                                            QR Droid Code Scanner
                                        </Bs>
                                        <Bs row>
                                        <QRCode size={72} value={"https://play.google.com/store/apps/details?id=la.droid.qr"} />
                                        </Bs>
                                        
                                    </Bs>
                                    <Bs row className="mt-4"><Bs span className="text-muted mt-4">
                                        <Bs row><Bs strong className="me-2 mb-2">iPhone</Bs></Bs>
                                        Pro použití QR kódu stačí otevřít aplokaci fotoaparát
                                    </Bs></Bs>
                                </Bs>
                                <Bs col xs={12} lg={6} className="d-flex justify-content-end">
                                    <QRCode value={"https://www.britex.cz/GetFile/" + this.state.id} />
                                </Bs>
                            </Bs>

                        </Bs>
                    </Bs>
                )}
                <Bs row>
                <Button disabled={this.state.show} variant="success" size="sm" onClick={() => this.setState({ show: true })}>{this.state.show ? <Bs brtxspin /> : "Mobile scan"}</Button>
                </Bs>
                
            </>
        )
    }
}

export default WebQrScan